import { attributeDefinitionIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const deleteAttributeDefinition = {
  name: "deleteAttributeDefinition" as const,
  input: z.object({
    attributeDefinitionId: attributeDefinitionIdFormat.schema,
  }),

  output: z.object({ success: z.boolean() }),
};
